import { useState, useMemo } from "react";

const FAQS = [
  { n: 1,  cat: "General",    q: "What products are available on Vedonica?",                   a: "Vedonica offers Ayurvedic products, herbal supplements, wellness powders, and natural health solutions for daily wellness." },
  { n: 2,  cat: "General",    q: "Are Vedonica products made with natural ingredients?",        a: "Yes, Vedonica uses natural and Ayurvedic ingredients designed for safe and effective wellness support." },
  { n: 3,  cat: "Ordering",   q: "How can I place an order on Vedonica?",                      a: "You can easily order Ayurvedic wellness products by adding items to your cart and completing secure checkout online." },
  { n: 4,  cat: "Fat Cutter", q: "What is Vedonica Vedo Fat Cutter Ras used for?",             a: "Vedonica Vedo Fat Cutter Ras helps support weight loss, fat management, and metabolism boost naturally with Ayurvedic ingredients." },
  { n: 5,  cat: "Fat Cutter", q: "How does Vedonica Fat Cutter Ras support metabolism?",       a: "The herbal metabolism booster formula may help improve digestion, reduce bloating, and support healthy calorie burning." },
  { n: 6,  cat: "Fat Cutter", q: "Can Vedonica Fat Cutter Ras help with belly fat?",           a: "Vedonica weight loss supplement is designed to support fat reduction and healthy weight management with regular exercise and diet." },
  { n: 7,  cat: "Fat Cutter", q: "Is Vedonica Fat Cutter Ras an Ayurvedic product?",           a: "Yes, Vedonica Fat Cutter Ras is made with Ayurvedic and herbal ingredients for natural wellness support." },
  { n: 8,  cat: "Fat Cutter", q: "How should I use Vedonica Fat Cutter Ras?",                  a: "Use the Vedonica metabolism boost supplement as directed on the label for best weight management results." },
  { n: 9,  cat: "Collagen",   q: "What is Vedonica Collagen used for?",                        a: "Vedonica Collagen helps support wrinkle reduction, skin hydration, and anti-aging skincare naturally." },
  { n: 10, cat: "Collagen",   q: "How does Vedonica Collagen improve skin health?",            a: "The collagen supplement may help improve skin elasticity, reduce fine lines, and support glowing skin." },
  { n: 11, cat: "Collagen",   q: "Can Vedonica Collagen help reduce wrinkles?",                a: "Yes, Vedonica anti-aging collagen is designed to support wrinkle reduction and youthful-looking skin." },
  { n: 12, cat: "Collagen",   q: "Is Vedonica Collagen good for daily use?",                   a: "Vedonica collagen supplement can be used daily to support healthy skin, hair, and beauty wellness." },
  { n: 13, cat: "Collagen",   q: "Why choose Vedonica Collagen for anti-aging support?",      a: "Vedonica Collagen combines beauty wellness and skin care support to help maintain smooth and healthy skin naturally." },
  { n: 14, cat: "General",    q: "Are Vedonica products suitable for men and women?",          a: "Yes, Vedonica wellness and Ayurvedic products are designed for both men and women." },
  { n: 15, cat: "General",    q: "Why choose Vedonica Ayurvedic products?",                   a: "Vedonica focuses on natural wellness, Ayurvedic ingredients, quality products, and trusted customer service for healthy living." },
];

const CATEGORIES = ["All", "General", "Fat Cutter", "Collagen", "Ordering"];

const CAT_TAG_COLORS = {
  General:    { bg: "#EAF3DE", color: "#27500A" },
  "Fat Cutter":{ bg: "#FFF7E6", color: "#854F0B" },
  Collagen:   { bg: "#EDE9FE", color: "#3C3489" },
  Ordering:   { bg: "#E0F2FE", color: "#0C447C" },
};

const styles = {
  page: {
    fontFamily: "sans-serif",
    maxWidth: 1060,
    margin: "0 auto",
    padding: "0rem 1rem",
    background: "#f8fdf4",
    minHeight: "100vh",
  },
  hero: {
    background: "linear-gradient(135deg, #3B6D11 0%, #639922 60%, #97C459 100%)",
    borderRadius: 16,
    padding: "3rem 2rem",
    textAlign: "center",
    marginBottom: "2rem",
    position: "relative",
    overflow: "hidden",
  },
  heroBadge: {
    display: "inline-block",
    background: "rgba(255,255,255,0.18)",
    color: "#fff",
    fontSize: 12,
    padding: "5px 16px",
    borderRadius: 20,
    marginBottom: "1rem",
    letterSpacing: "0.5px",
  },
  heroTitle: {
    fontSize: 30,
    fontWeight: 700,
    color: "#fff",
    margin: "0 0 8px",
  },
  heroSub: {
    fontSize: 15,
    color: "rgba(255,255,255,0.85)",
    margin: 0,
  },
  searchWrap: {
    position: "relative",
    maxWidth: 420,
    margin: "1.5rem auto 0",
  },
  searchIcon: {
    position: "absolute",
    left: 14,
    top: "50%",
    transform: "translateY(-50%)",
    color: "#639922",
    fontSize: 18,
    pointerEvents: "none",
  },
  searchInput: {
    width: "100%",
    padding: "12px 16px 12px 42px",
    borderRadius: 30,
    border: "none",
    fontSize: 14,
    background: "#fff",
    color: "#2C2C2A",
    outline: "none",
    boxSizing: "border-box",
  },
  stats: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 12,
    marginBottom: "1.5rem",
  },
  statCard: {
    background: "#fff",
    border: "1px solid #C0DD97",
    borderRadius: 10,
    padding: "0.85rem 1rem",
    textAlign: "center",
  },
  statNum: {
    fontSize: 24,
    fontWeight: 700,
    color: "#3B6D11",
  },
  statLbl: {
    fontSize: 12,
    color: "#5F5E5A",
    marginTop: 2,
  },
  cats: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: "1.5rem",
    justifyContent: "center",
  },
  faqList: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  faqItem: (isOpen) => ({
    background: "#fff",
    border: `1.5px solid ${isOpen ? "#639922" : "#C0DD97"}`,
    borderRadius: 12,
    overflow: "hidden",
    transition: "border-color 0.2s",
  }),
  faqQ: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "1rem 1.25rem",
    cursor: "pointer",
    userSelect: "none",
  },
  faqNum: (isOpen) => ({
    minWidth: 28,
    height: 28,
    borderRadius: "50%",
    background: isOpen ? "#3B6D11" : "#EAF3DE",
    color: isOpen ? "#fff" : "#3B6D11",
    fontSize: 12,
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    transition: "all 0.2s",
  }),
  faqQText: {
    flex: 1,
    fontSize: 14,
    fontWeight: 600,
    color: "#1a1a1a",
    lineHeight: 1.5,
  },
  faqChevron: (isOpen) => ({
    fontSize: 18,
    color: "#639922",
    transition: "transform 0.25s",
    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
    flexShrink: 0,
  }),
  faqAInner: {
    padding: "0 1.25rem 1rem 4.25rem",
    borderTop: "1px dashed #C0DD97",
  },
  tag: (cat) => ({
    display: "inline-block",
    fontSize: 11,
    background: CAT_TAG_COLORS[cat]?.bg || "#EAF3DE",
    color: CAT_TAG_COLORS[cat]?.color || "#27500A",
    padding: "2px 10px",
    borderRadius: 12,
    marginTop: 10,
    marginBottom: 6,
    fontWeight: 500,
  }),
  faqAText: {
    fontSize: 14,
    color: "#444",
    lineHeight: 1.75,
    margin: 0,
  },
  empty: {
    textAlign: "center",
    padding: "3rem",
    color: "#888",
  },
  footerNote: {
    marginTop: "2rem",
    textAlign: "center",
    fontSize: 13,
    color: "#5F5E5A",
    padding: "1.25rem",
    background: "#EAF3DE",
    borderRadius: 10,
  },
  footerLink: {
    color: "#3B6D11",
    textDecoration: "none",
    fontWeight: 600,
  },
};

// ── Category pill button ────────────────────────────────────
function CatButton({ label, active, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: "7px 18px",
        borderRadius: 20,
        border: `1.5px solid ${active ? "#3B6D11" : "#C0DD97"}`,
        background: active ? "#3B6D11" : "transparent",
        color: active ? "#fff" : "#3B6D11",
        fontSize: 13,
        cursor: "pointer",
        fontWeight: 500,
        transition: "all 0.18s",
      }}
    >
      {label}
    </button>
  );
}

// ── Single FAQ accordion item ───────────────────────────────
function FAQItem({ faq, isOpen, onToggle }) {
  return (
    <div style={styles.faqItem(isOpen)}>
      <div style={styles.faqQ} onClick={onToggle} role="button" aria-expanded={isOpen}>
        <div style={styles.faqNum(isOpen)}>{faq.n}</div>
        <div style={styles.faqQText}>{faq.q}</div>
        <span style={styles.faqChevron(isOpen)}>&#8964;</span>
      </div>

      {isOpen && (
        <div style={styles.faqAInner}>
          <span style={styles.tag(faq.cat)}>{faq.cat}</span>
          <p style={styles.faqAText}>{faq.a}</p>
        </div>
      )}
    </div>
  );
}

// ── Main FAQ Page component ─────────────────────────────────
export default function VedonicaFAQ() {
  const [search, setSearch]       = useState("");
  const [activeCat, setActiveCat] = useState("All");
  const [openIdx, setOpenIdx]     = useState(null);

  const filtered = useMemo(() => {
    const q = search.toLowerCase().trim();
    return FAQS.filter(f => {
      const catOk    = activeCat === "All" || f.cat === activeCat;
      const searchOk = !q || f.q.toLowerCase().includes(q) || f.a.toLowerCase().includes(q);
      return catOk && searchOk;
    });
  }, [search, activeCat]);

  const handleToggle = (n) => setOpenIdx(prev => prev === n ? null : n);

  const handleCat = (cat) => {
    setActiveCat(cat);
    setOpenIdx(null);
  };

  return (
    <div style={styles.page}>
{/* ── Hero ── */}
<div style={styles.hero}>
  <div style={styles.heroBadge}>
    <i className="ti ti-leaf" aria-hidden="true" />
    Vedonica International Help Center
  </div>
  <h1 style={styles.heroTitle}>Frequently Asked Questions</h1>
  <h6 style={styles.heroSub}>Everything you need to know about our Ayurvedic wellness products</h6>
</div>
      

      {/* ── Category filter ── */}
      <div style={styles.cats}>
        {CATEGORIES.map(cat => (
          <CatButton
            key={cat}
            label={cat}
            active={activeCat === cat}
            onClick={() => handleCat(cat)}
          />
        ))}
      </div>

      {/* ── FAQ list ── */}
      {filtered.length === 0 ? (
        <div style={styles.empty}>
          <div style={{ fontSize: 40, marginBottom: 12 }}></div>
          <div>No questions found. Try a different search or category.</div>
        </div>
      ) : (
        <div style={styles.faqList}>
          {filtered.map(faq => (
            <FAQItem
              key={faq.n}
              faq={faq}
              isOpen={openIdx === faq.n}
              onToggle={() => handleToggle(faq.n)}
            />
          ))}
        </div>
      )}

      {/* ── Footer ── */}
      <div style={styles.footerNote}>
        💚 Still have questions?{" "}
        <a href="mailto:vedonicainternational@gmail.com" style={styles.footerLink}>
          Contact our wellness team
        </a>{" "}
        — we're happy to help!
      </div>
    </div>
  );
}